/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { Grid, TextField, Autocomplete, Button } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { setFormValues } from "../../../app/slices/applicationsSlice";
import IconDelete from "@mui/icons-material/Delete";
import nationalities from "../../../assets/static/nationalities.json";
import { validate } from "validate.js";
import { addDirectorSchema } from "../validationSchemas";
import {
  addStakeholder,
  updateStakeholder,
  fetchStakeholders,
  resetStateStakeholders,
} from "../../../app/slices/stakeholdersSlice";
import LoadingContainer from "../../../components/loadingContainer/loadingContainer";

const DirectorsFragment = ({ errors: formErrors }) => {
  const { formValues } = useSelector(({ applications }) => applications);
  const { data: dataPost } = useSelector(
    ({ stakeholders }) => stakeholders.post
  );
  const { data: dataPut } = useSelector(({ stakeholders }) => stakeholders.put);
  const { list: listStakeholders, status: statusGet } = useSelector(
    ({ stakeholders }) => stakeholders.get
  );
  const [localFormValues, setLocalFormValues] = useState({});
  const [errors, setErrors] = useState([]);
  const [list, setList] = useState([]);
  const [rebuild, setRebuild] = useState(true);
  const dispatch = useDispatch();

  //use effects
  useEffect(() => {
    loadResources();
    return () => {
      dispatch(resetStateStakeholders());
    };
  }, []);

  useEffect(() => {
    if (list) {
      dispatch(
        setFormValues({
          ...formValues,
          directors: [...list],
        })
      );
    }
  }, [list]);

  useEffect(() => {
    if (listStakeholders?.length > 0) {
      let _list = [];
      listStakeholders?.forEach((row) => {
        _list.push({
          id: row?.STAKEHOLDER_ID,
          name: row?.FULL_NAME,
          nationality: row?.NATIONALITY,
          phone: row?.PHONE_NUMBER,
          email: row?.EMAIL,
          designation: row?.DESIGNATION,
          educationQualification: row?.EDUCATION,
        });
      });
      setList(_list);
    } else {
      setList([]);
    }
  }, [listStakeholders]);

  useEffect(() => {
    if (dataPost || dataPut) {
      loadResources();
      setLocalFormValues({});
      setRebuild(false);
      setTimeout(() => {
        setRebuild(true);
      }, 400);
    }
  }, [dataPost, dataPut]);

  //methods
  const handleChange = (e) => {
    let inputName = e?.target?.name;
    let inputValue = e?.target?.value;

    if (inputName === "phone") {
      const re = /^[0-9,+]*$/;
      if (inputValue === "" || re.test(inputValue)) {
        setLocalFormValues({
          ...localFormValues,
          [inputName]: inputValue,
        });
      }
    } else {
      setLocalFormValues({
        ...localFormValues,
        [inputName]: inputValue,
      });
    }
  };

  const handleAddRow = () => {
    let _errors = validate(localFormValues, addDirectorSchema);

    if (_errors) {
      setErrors(_errors);
      return;
    } else {
      setErrors([]);
    }

    dispatch(
      addStakeholder({
        APPLICATION_ID: formValues?.applicationId,
        FULL_NAME: localFormValues?.fullName,
        NATIONALITY: localFormValues?.nationality,
        PHONE_NUMBER: localFormValues?.phone,
        EMAIL: localFormValues?.email,
        TYPE: "D",
        EDUCATION: localFormValues?.educationQualification,
        DESIGNATION: localFormValues?.designation,
      })
    );
  };

  const handleRemoveRow = (index) => {
    dispatch(
      updateStakeholder({
        id: list[index]?.id,
        payload: {
          STATUS: "I",
        },
      })
    );
  };

  const loadResources = () => {
    dispatch(resetStateStakeholders());
    dispatch(
      fetchStakeholders({
        TYPE: "D",
        APPLICATION_ID: formValues?.applicationId,
        STATUS: "A",
      })
    );
  };

  //builders
  const BuildForm = () => {
    return (
      <div
        style={{
          background: "#f1f1f1",
          padding: "10px 20px",
          borderRadius: "10px",
          margin: "20px 0",
        }}
      >
        <Grid container>
          <Grid item xs={12} md={12} className="padded-grid-item">
            <b>Add Director</b>
          </Grid>
          <Grid item xs={12} sm={4} md={3} className="padded-grid-item">
            <TextField
              key={"input-full-name"}
              required
              fullWidth
              margin="dense"
              autoComplete="new-password"
              variant="outlined"
              error={errors["fullName"] ? true : false}
              helperText={errors["fullName"] ? errors.fullName[0] : null}
              name="fullName"
              id="fullName"
              label="Full Name"
              onChange={handleChange}
              value={localFormValues?.fullName || ""}
            />
          </Grid>
          <Grid item xs={12} sm={4} md={3} className="padded-grid-item">
            {rebuild && (
              <Autocomplete
                id="auto-complete-nationality"
                options={nationalities}
                onChange={(event, value) => {
                  handleChange({
                    target: { value: value, name: "nationality" },
                  });
                }}
                getOptionLabel={(option) => `${option}`}
                renderOption={(props, option) => (
                  <div {...props} style={{ fontSize: "12px" }}>
                    {`${option}`}
                  </div>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Nationality"
                    variant="outlined"
                    name="nationality"
                    error={errors["nationality"] ? true : false}
                    helperText={
                      errors["nationality"] ? errors.nationality[0] : null
                    }
                    required={true}
                    margin="dense"
                    inputProps={{
                      ...params.inputProps,
                      id: "nationality-input",
                    }}
                  />
                )}
              />
            )}
          </Grid>
          <Grid item xs={12} sm={4} md={3} className="padded-grid-item">
            <TextField
              key={"input-designation"}
              required
              fullWidth
              margin="dense"
              autoComplete="new-password"
              variant="outlined"
              error={errors["designation"] ? true : false}
              helperText={errors["designation"] ? errors.designation[0] : null}
              name="designation"
              id="designation"
              label="Designation"
              onChange={handleChange}
              value={localFormValues?.designation || ""}
            />
          </Grid>
          <Grid item xs={12} sm={4} md={3} className="padded-grid-item">
            <TextField
              key={"input-phone"}
              required
              fullWidth
              margin="dense"
              autoComplete="new-password"
              variant="outlined"
              error={errors["phone"] ? true : false}
              helperText={errors["phone"] ? errors.phone[0] : null}
              name="phone"
              id="phone"
              label="Phone Number"
              onChange={handleChange}
              value={localFormValues?.phone || ""}
            />
          </Grid>
          <Grid item xs={12} sm={4} md={3} className="padded-grid-item">
            <TextField
              key={"input-email"}
              required
              fullWidth
              margin="dense"
              autoComplete="new-password"
              variant="outlined"
              error={errors["email"] ? true : false}
              helperText={errors["email"] ? errors.email[0] : null}
              name="email"
              id="email"
              label="Email"
              onChange={handleChange}
              value={localFormValues?.email || ""}
            />
          </Grid>
          <Grid item xs={12} sm={4} md={3} className="padded-grid-item">
            <TextField
              key={"input-education-qualification"}
              required
              fullWidth
              margin="dense"
              autoComplete="new-password"
              variant="outlined"
              error={errors["educationQualification"] ? true : false}
              helperText={
                errors["educationQualification"]
                  ? errors.educationQualification[0]
                  : null
              }
              name="educationQualification"
              id="educationQualification"
              label="Education Qualification"
              onChange={handleChange}
              value={localFormValues?.educationQualification || ""}
            />
          </Grid>
          <Grid item xs={12} md={12} className="padded-grid-item">
            <div className="flex-row justify-content-end ">
              <Button
                className="btn-login flex-row"
                variant="contained"
                onClick={handleAddRow}
                margin="dense"
                size="medium"
                color="secondary"
                // disabled={getButtonDisabledStatus()}
                style={{ textTransform: "unset" }}
              >
                + Add
              </Button>
            </div>
          </Grid>
        </Grid>
      </div>
    );
  };

  const BuildTable = () => {
    return (
      <>
        {statusGet === "idle" && (
          <table className="stakeholders-table">
            <thead>
              <th>S/N</th>
              <th>Full Name</th>
              <th>Nationality</th>
              <th>Telephone</th>
              <th>Designation</th>
              <th>Email</th>
              <th>Education</th>
              <th></th>
            </thead>
            <tbody>
              {list?.length === 0 && (
                <tr>
                  <td colSpan={8} className="text-align-center text-muted">
                    No directors added
                  </td>
                </tr>
              )}
              {list?.length > 0 && (
                <>
                  {list?.map((row, index) => (
                    <tr>
                      <td className="td-50 text-align-center">{index + 1}</td>
                      <td>{row?.name}</td>
                      <td>{row?.nationality}</td>
                      <td>{row?.phone}</td>
                      <td>{row?.designation}</td>
                      <td>{row?.email}</td>
                      <td>{row?.educationQualification}</td>
                      <td className="td-50 delete-icon">
                        <div className="flex-row justify-content-center">
                          <IconDelete
                            onClick={() => {
                              if (window.confirm("Remove director?")) {
                                handleRemoveRow(index);
                              }
                            }}
                          />
                        </div>
                      </td>
                    </tr>
                  ))}
                </>
              )}
            </tbody>
          </table>
        )}
        {statusGet === "loading" && (
          <LoadingContainer
            message="Loading..."
            hasBackground={false}
            hasFixedHeight={false}
          />
        )}
      </>
    );
  };

  return (
    <div className="app-padding">
      <h2 className="mb-10">Directors</h2>
      <div>
        Provide company directors details. Fill in the form and click "add"
        button to insert a director in the table below.
      </div>
      {BuildForm()}
      {BuildTable()}
      {formErrors?.directors && (
        <div className="flex-row mb-10 mt-20 align-items-center">
          <div className="list-bullet mr-10"></div>
          <div className="text-red">{formErrors?.directors?.[0]}</div>
        </div>
      )}
    </div>
  );
};

export default DirectorsFragment;
